import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig';
import AxiosPostProcessor from './AxiosPostProcessor';
import Axios, { AxiosResponse } from 'axios';
import ExtentModel from '@/ExtentModel';

export class LocationServiceStatic {
    DefaultExtent(): Promise<AxiosResponse<ExtentModel>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/defaultextent`
        return AxiosPostProcessor.postProcess(Axios.get<ExtentModel>(url, AxiosDefaultRequestConfig.merge({ })));
    }
}
const LocationService = new LocationServiceStatic();
export default LocationService;
